// 客户端译文查表。目录由 layouts/application.html.erb 内联成一个 JSON 节点，
// 单一来源仍是 config/locales/*.yml——服务端和客户端不可能对不上。
//
// 插值沿用 Rails 的 %{} 语法：同一句话将来从客户端挪到服务端（或反过来）时
// 不用重写占位符。

type Plural = { one?: string; other: string }
type Entry = string | Plural

let catalog: Record<string, Entry> = {}
const reported = new Set<string>()

export function initCatalog(): void {
  const node = document.getElementById('i18n-catalog')
  // layouts/legal.html.erb 根本不加载 React，也没有这个节点——不能因此炸掉。
  if (!node?.textContent) return
  catalog = JSON.parse(node.textContent)
}

export function t(key: string, vars?: Record<string, string | number>): string {
  const entry = catalog[key]
  if (entry === undefined) return missing(key)

  const template =
    typeof entry === 'string'
      ? entry
      : vars?.count === 1 && entry.one !== undefined
        ? entry.one
        : entry.other

  return interpolate(template, vars)
}

function interpolate(template: string, vars?: Record<string, string | number>): string {
  if (!vars) return template
  return template.replace(/%\{(\w+)\}/g, (whole, name) =>
    vars[name] === undefined ? whole : String(vars[name]),
  )
}

function missing(key: string): string {
  // 开发期直接炸，别让漏译静默溜到生产。
  if (import.meta.env.DEV) throw new Error(`[i18n] 缺少译文：${key}`)

  // 生产返回 key 本身（比空白可查），每个 key 只上报一次——别刷爆日志。
  if (!reported.has(key)) {
    reported.add(key)
    console.warn(`[i18n] 缺少译文：${key}`)
  }
  return key
}
